import { toast } from 'react-toastify'

import api from '../../../lib/api'

export const USERS_FETCHING = 'USERS_FETCHING'
export const USERS_DONE = 'USERS_DONE'
export const USERS_FAILED = 'USERS_FAILED'

const requestUsers = () => ({
  type: USERS_FETCHING,
})

const receiveUsers = (userList, pageTotal, page) => ({
  type: USERS_DONE,
  userList,
  pageTotal,
  page,
})

const fetchFailed = message => ({
  type: USERS_FAILED,
  message,
})

export const fetchUsers = (
  organisationId,
  dispatch,
  page = 0,
  t,
  filteredOrganisation
) => {
  dispatch(requestUsers())

  const usersUrl = `/orgs/${filteredOrganisation ||
    organisationId}/users?page=${page + 1}&limit=10`

  api
    .get(usersUrl)
    .then(({ data, headers: { fm_pagination_total } }) => {
      const pageTotal = Math.ceil(fm_pagination_total / 10)
      dispatch(receiveUsers(data, pageTotal, page))
    })
    .catch(err => {
      console.log(err)
      dispatch(fetchFailed(err.message))
      toast.error(t('job_detail_fetch_unsuccessful'))
    })
}

export const removeUser = (organisationId, userId, t, dispatch, page = 0) =>
  api
    .delete(`/orgs/${organisationId}/users/${userId}`)
    .then(() => {
      toast.success(t('users_delete_successful'))
      fetchUsers(organisationId, dispatch, page, t)
    })
    .catch(err => {
      toast.error(t('users_delete_unsuccessful'))
      console.log(err)
    })
